import { useMutation, useQueryClient } from "@tanstack/react-query";
import { register as RegisterApi } from "../../services/apiAuth";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const useRegister = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { isPending, mutate: signIn, error } = useMutation({
    mutationFn: (obj) => RegisterApi(obj),
    onSuccess: (data) => {
      console.log("data on useRegister:", data);

      // localStorage.setItem("authUser", JSON.stringify(data.prospect));
      // localStorage.setItem("count", JSON.stringify(data.count.count));
      // toast.success(
      //   "Registration completed successfully. Please check your email.",
      //   { duration: 10000 }
      // );
      queryClient.setQueryData(["authUser"], data);
      navigate("/demo-titleminer", { replace: true });
    },
    onError: (error) => {
      console.log("Error Object:", error);

        if (error?.status === 400) {
            const errorMessage = error.data?.email_id?.[0] || "This email is already registered. Please use a different one.";
            toast.error(errorMessage);
        } else {
            toast.error("An unexpected error occurred. Please try again.");
        }
    },
  });

  return { isPending, signIn, error };
};

export default useRegister;
